<template>
  <div v-if="showSpinner" class="content">
    <LoadingSpinner />
  </div>
  <div v-else class="content max-700 m-auto">
    <GetStarted />
  </div>
</template>
<script setup lang="ts">
import { onBeforeMount, ref } from "vue";
import GetStarted from "@/components/Aol/GetStarted.vue";
import LoadingSpinner from "@/components/shared/LoadingSpinner.vue";
import { validateAolToken } from "@/components/Aol//AolCreateAccountHelper";
import { useRoute } from "vue-router";
import { checkAndLoadGtm } from "@/common/googleTagEvents";

const route = useRoute();
const showSpinner = ref(true);

onBeforeMount(async () => {
  showSpinner.value = !(await validateAolToken(route));

  checkAndLoadGtm();
});
</script>
